import { createStyles, Theme } from '@material-ui/core/styles';

const style = (theme: Theme) => createStyles({

    selectButton: {
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main,
        color: theme.palette.text.primary,

        '& svg': {
            margin: 0,
            marginRight: -6,
            fontSize: 20,
            color: 'rgba(0, 0, 0, 0.54)',
        },

        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.primary.main,
        },

        '&>span': {
            lineHeight: 1.5,
        },
    },

    buttonLabel: {
        width: '100%',
        textAlign: 'left',
    },

});

export default style;
